const initialData = {
  supportedIds: [56],
};
export function ChainReducer(state = initialData, action) {
  switch (action.type) {
    default:
      return state;
  }
}
